// extracted by mini-css-extract-plugin
module.exports = {"SiteLogo":"SiteLogo_SiteLogo__CdNXA","bow":"SiteLogo_bow__v2EPz","wobble":"SiteLogo_wobble__5h66F"};